export default __webpack_public_path__ + "static/media/my.32e3e451.svg";